import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { DetailTepProjetComponent } from '../detail-tep-projet/detail-tep-projet.component';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';

@Component({
  selector: 'app-tep-projet',
  templateUrl: './tep-projet.component.html',
  styleUrl: './tep-projet.component.scss'
})



export class TepProjetComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  projetData: any = [] = [];
  annee: any;
  modalRef: NgbModalRef | null = null;
  isLoading: boolean = false;
  searchTerm: string = '';
  dateDebut: string;
  dateFin: string;
  itemToDelete!: ProjetIndicateur;
  filteredtems: any = [];
  projetId: any
  pageSize: number = 10;
  pdfUrl: string;
  excelUrl: string;

  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  paginatedProjets: any = [];

  projetItems: any = [];
  selectedProjet: any;
  directionId: any;
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any;
// Ajouter ces propriétés
  histogramData: any = {};
  chartOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    const today = new Date();
  
     const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];

  }

  ngOnInit(): void {

    this.projetId = this.localstorage.getProjetToUser();

    this.userInfo = this.localstorage.getInfoUserToService();

    if (this.userInfo?.data?.groupe === "admin") {

      this.showFiltre = true;
      this.getDirection();
    }
    if (this.userInfo?.data?.groupe === "point_focal") {
      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;
      this.getProjetByDirection(this.directionId);
    }
    //statistiques par defaut

    this.getStatistique();
  }

  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    )
  }
  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
        // this.getExercice();
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);
      }
    )

  }

  //recuperation des statistiques
  getStatistique() {
    //check
    if (!this.dateDebut) {
      this.messageService.add({ severity: 'info', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (!this.dateFin) {
      this.messageService.add({ severity: 'info', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    const savedate = {

      "date_debut": this.dateDebut,
      "date_fin": this.dateFin
    }

    this.localstorage.saveDateToDetail(savedate)

    //  //console.log("fff");

    //
    this.isLoading = true;
    this.ngxService.start();
    this.paramservice.getStatistiqueTepProjet(this.annee, this.dateDebut, this.dateFin, this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.isLoading = false;

        if (response.data !== undefined) {

          this.projetData = response.data;
          this.totalRecords = this.projetData.length;
          this.updatePaginatedProjets();
          this.prepareHistogramData();
        } else {

        }

      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error.error.message || "une erreur est survenu", life: 3000 });
        this.isLoading = false;
      }
    );
  }//end getStatistique


  // Ajouter cette méthode
prepareHistogramData() {
  if (!this.projetData || this.projetData.length === 0) return;

  const labels = this.projetData.map((item: any) => {
    const libelle = item?.programme?.libelle || 'N/A';
    return libelle.length > 25 ? libelle.substring(0, 23) + '...' : libelle;
  });

  this.histogramData = {
    labels: labels,
    datasets: [
      {
        label: 'TEP Prévu (%)',
        data: this.projetData.map((item: any) => parseFloat(item.tep_prevu) || 0),
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.7
      },
      {
        label: 'TEP Réalisé (%)',
        data: this.projetData.map((item: any) => parseFloat(item.tep_realise) || 0),
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.7
      }
    ]
  };

  this.chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: 12, weight: 'bold' }, usePointStyle: true }
      },
      title: {
        display: true,
        text: `Comparaison TEP Prévu vs Réalisé par Programme - ${this.annee}`,
        font: { size: 16, weight: 'bold' },
        padding: { top: 10, bottom: 20 }
      },
      tooltip: {
        callbacks: {
          label: (context: any) => `${context.dataset.label}: ${context.raw}%`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: { display: true, text: 'TEP (%)', font: { weight: 'bold' } },
        ticks: {
          callback: (value: any) => value + '%',
          stepSize: 20
        },
        grid: { color: 'rgba(0,0,0,0.05)' }
      },
      x: {
        title: { display: true, text: 'Programmes', font: { weight: 'bold' } },
        ticks: { maxRotation: 35, minRotation: 35 }
      }
    }
  };
}

  onPageChangeProjets(event:any) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.projetData.slice(start, end);
  }//end updatePaginatedProjets


  //imprime en pdf et excel
  exportToDocument(typeDoc: any) {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    this.ngxService.start();

    // save date debut et fin


    //end
    this.paramservice.printStatistiqueTepProjetAsFile(this.annee, this.directionId, this.dateDebut, this.dateFin, typeDoc, this.userInfo?.data?.reference).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_Activite_Projet.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_Activite_Projet.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }//end exportToDocument

  roundToTwoDecimals(num:any) {
    return Math.round(num * 100) / 100;
  }


  //detaila ctivite budgetaire
  detailsProjet(item: any) {

    this.localstorage.saveTepProjet(item);

    const modalRef = this.modalService.open(DetailTepProjetComponent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);
  }//end detailsProjet


}
